module.exports = __webpack_public_path__ + "images/dealerlabellease_smallc44001333ef460623c320f0040bc2eba.png";